"use client";

import Link from 'next/link';

const CompareCTA = () => {
  return (
    <div className="text-center pt-8">
      <Link
        href="/"
        className="inline-block bg-cyan-600 text-white font-bold text-lg px-6 py-3 rounded-lg hover:bg-cyan-700 transition-colors duration-200"
        rel="nofollow"
      >
        Compare & Book Dive Courses or Fun Dives
      </Link>
    </div>
  );
};

export default CompareCTA;
